import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import IosShareIcon from '@mui/icons-material/IosShare';
import { HeaderFixed } from '@/components';

import styles from './FlyerDetailsHeader.styles';
import { BodyLargeMidEmphasis } from '@/design-system';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '@/config/constants';

interface FlyerDetailsHeaderProps {
  onShare: () => void;
  goToPreviousPage: () => void;
  onClickFavorite: () => void;
  isFavorite: boolean;
  flyerType: string;
  isNonActive?: boolean;
}

export const FlyerDetailsHeader: React.FC<FlyerDetailsHeaderProps> = ({
  onShare,
  goToPreviousPage,
  onClickFavorite,
  isFavorite,
  flyerType,
  isNonActive = false,
}) => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const originParam = searchParams.get('origin');

  const onBackButtonClick = () => {
    if(originParam) {
      navigate(`${APP_ROUTES.exploreNewFlyers}?tab=${flyerType}`);
    }
    else {
      goToPreviousPage();
    }
  }
  return (
    <HeaderFixed>
      <div className={styles.container} data-testid="flyerDetailsHeader">
        <nav className={styles.content} aria-label="Flyer details header">
          <div className={styles.backButtton} onClick={onBackButtonClick}>
            <IconButton
              aria-label="Back button"
              data-testid="backButton"
            >
              <CloseOutlinedIcon />
            </IconButton>
            {originParam && <BodyLargeMidEmphasis>New Flyers</BodyLargeMidEmphasis>}
          </div>
          {!isNonActive && (
            <>
              <IconButton
                onClick={onClickFavorite}
                aria-label="Mark flyer as favorite"
                data-testid="favoriteButton"
                aria-pressed={isFavorite}
              >
                {isFavorite ? (
                  <StarRoundedIcon
                    sx={{ fontSize: 45 }}
                    className={styles.favoriteIconSelected}
                  />
                ) : (
                  <StarOutlineRoundedIcon sx={{ fontSize: 45 }} />
                )}
              </IconButton>
              <div className={styles.shareButton}>
                <IconButton
                  onClick={onShare}
                  aria-label="Share flyer button"
                  data-testid="shareFlyerButton"
                >
                  <IosShareIcon />
                </IconButton>
              </div>
            </>
          )}
        </nav>
      </div>
    </HeaderFixed>
  );
};

